export const PROVIDER_BRANDS = {
  LAD_ES: 'Llamando al Doctor',
  LAD_PT: 'Chamando o Doutor',
  LAD_EN: 'Calling the Doctor'
};

export type ProviderBrand = (typeof PROVIDER_BRANDS)[keyof typeof PROVIDER_BRANDS];
